<template>
  <div class="mt-4">
    <template v-if="fromStayPlace">
      <stay-place :place="place" />
    </template>
    <template v-else-if="from.route">
      <add-place :place="place" />
    </template>
    <template v-else>
      <route-place :place="place" />
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AddPlace from './AddPlace'
import StayPlace from './StayPlace'
import RoutePlace from './RoutePlace'

export default {
  components: {
    AddPlace,
    StayPlace,
    RoutePlace
  },
  data () {
    return {
      fromStayPlace: false
    }
  },
  created () {
    const changeProfile = this.$store.getters['user/getChangeProfile']
    if (changeProfile !== null){
      this.fromStayPlace = true
    }
  },
  props: {
    place: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      from: 'map/getFrom',
    })
  }
}
</script>
